import type { ExtraLine, Meal } from '../../domain/types.js';
import type { StoredDinner, StoredPlan } from '../store/db.js';
import { isCustomId } from '../store/library.js';

/**
 * Hazard 2. Emily's plan can reach this phone a moment before the recipe it
 * names does. The engine is right to throw on an unknown meal — for bundled
 * data that is a real bug — so the UI boundary sets aside ONLY custom dinners
 * it cannot resolve yet, says so on screen, and builds everything else.
 */
export function withoutUnresolved(
  plan: StoredPlan,
  byId: ReadonlyMap<string, Meal>,
): { plan: StoredPlan; missing: StoredDinner[] } {
  const missing = plan.dinners.filter((d) => isCustomId(d.mealId) && !byId.has(d.mealId));
  if (missing.length === 0) return { plan, missing };
  const gone = new Set(missing);
  return { plan: { ...plan, dinners: plan.dinners.filter((d) => !gone.has(d)) }, missing };
}

/** "Gochujang — 3.1 tbsp", or just "Sesame seeds" when the recipe said "some". */
export function extraLineLabel(line: ExtraLine): string {
  if (line.qty === null) return line.label;
  return `${line.label} — ${line.qty} ${line.unitLabel}`.trim();
}
